export default [
    {
        name: "WarehouseCreate",
        path: "warehouse",
        component: () => import('./../../views/warehouse/WarehouseCreateView.vue')
    },
    {
        name: "WarehouseDisplay",
        path: "warehouse/:id",
        component: () => import('./../../views/warehouse/WarehouseDisplayView.vue')
    },
    {
        name: "WarehouseEdit",
        path: "warehouse/:id/edit",
        component: () => import('./../../views/warehouse/WarehouseEditView.vue')
    },
    {
        name: "WarehouseList",
        path: "warehouses",
        component: () => import('./../../views/warehouse/WarehouseListView.vue')   
    }
]